import { __assign, __rest } from "tslib";
import React from 'react';
import VeltRecordingPreviewStepsDialogTimerCountdownWireframe from './VeltRecordingPreviewStepsDialogTimerCountdownWireframe/VeltRecordingPreviewStepsDialogTimerCountdownWireframe';
import VeltRecordingPreviewStepsDialogTimerCancelWireframe from './VeltRecordingPreviewStepsDialogTimerCancelWireframe/VeltRecordingPreviewStepsDialogTimerCancelWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltRecordingPreviewStepsDialogTimerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-timer-wireframe", __assign({}, transformedProps), children));
};
VeltRecordingPreviewStepsDialogTimerWireframe.Countdown = VeltRecordingPreviewStepsDialogTimerCountdownWireframe;
VeltRecordingPreviewStepsDialogTimerWireframe.Cancel = VeltRecordingPreviewStepsDialogTimerCancelWireframe;
export default VeltRecordingPreviewStepsDialogTimerWireframe;
